// 機能の表示/非表示を制御する設定

interface FeatureFlags {
  converter: boolean;
  debugMode: boolean;
  adminFeatures: boolean;
}

// 環境変数から機能フラグを取得
const getFeatureFlags = (): FeatureFlags => {
  const isDevelopment = import.meta.env.DEV;
  const isLocalhost = window.location.hostname === 'localhost' || window.location.hostname === '127.0.0.1';
  const isAdminMode = import.meta.env.VITE_ADMIN_MODE === 'true';
  const isSessionAdmin = sessionStorage.getItem('adminMode') === 'true';
  
  return {
    converter: isDevelopment || isLocalhost || isAdminMode || isSessionAdmin,
    debugMode: false, // デバッグモードを無効化
    adminFeatures: isDevelopment || isLocalhost || isAdminMode || isSessionAdmin,
  };
};

export const featureFlags = getFeatureFlags();

// 機能が有効かどうかをチェックする関数
export const isFeatureEnabled = (feature: keyof FeatureFlags): boolean => {
  return featureFlags[feature];
};

// 管理者モードかどうかをチェック
export const isAdminMode = (): boolean => {
  return featureFlags.adminFeatures;
};
